import React from "react";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";
import useSupplierPaymentForm from "./useSupplierPaymentForm";

const SupplierPaymentForm = ({
  onClose,
  onPrintReady,
  mode = "create",
  editData = null,
}) => {
  const {
    formik,
    shopOptions,
    paymentOptions,
    isBasicDataLoading,
    isSubmitting,
    getFieldError,
  } = useSupplierPaymentForm({ onClose, onPrintReady, mode, editData });

  return (
    <div className="pro-m-5">
      <h5 className="pro-ttl pro-mb-4">
        {mode === "edit" ? "Edit Supplier Payment" : "Supplier Payment"}
      </h5>

      <div className="input-wrap pro-mb-4">
        <label
          htmlFor="supplier_id"
          className="pro-font-sm pro-mb-1 pro-fw-medium"
        >
          Customer Name
        </label>
        <Select
          id="supplier_id"
          placeholder={"Select"}
          className={`pro-input lg ${getFieldError("supplier_id") && " error"}`}
          classNamePrefix="pro-input"
          isMulti={false}
          name="supplier_id"
          options={shopOptions}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={shopOptions?.filter(
            (p) => p._id === formik.values.supplier_id,
          )}
          onChange={(value) =>
            formik.setFieldValue("supplier_id", value?._id ?? "")
          }
          isLoading={isBasicDataLoading}
          menuPlacement="auto"
        />
        {getFieldError("supplier_id") && (
          <span className="error-text">{getFieldError("supplier_id")}</span>
        )}
      </div>

      <div className="input-wrap pro-mb-4">
        <label
          htmlFor="payment_method"
          className="pro-font-sm pro-mb-1 pro-fw-medium"
        >
          Payment Method
        </label>
        <Select
          id="payment_method"
          placeholder={"Select"}
          className={`pro-input lg ${getFieldError("payment_method") && " error"}`}
          classNamePrefix="pro-input"
          isMulti={false}
          name="payment_method"
          options={paymentOptions}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.name}
          value={paymentOptions?.filter(
            (p) => p.id === formik.values.payment_method,
          )}
          onChange={(value) =>
            formik.setFieldValue("payment_method", value?.id ?? "")
          }
          isLoading={isBasicDataLoading}
          menuPlacement="auto"
        />
        {getFieldError("payment_method") && (
          <span className="error-text">{getFieldError("payment_method")}</span>
        )}
      </div>

      <div className="input-wrap pro-mb-4">
        <Input
          label={"Received Amount"}
          type="number"
          id="received_amount"
          name="received_amount"
          className={`pro-input lg ${
            getFieldError("received_amount") && " error"
          }`}
          {...formik.getFieldProps("received_amount")}
          error={getFieldError("received_amount")}
          errorMessage={getFieldError("received_amount")}
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="remark" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Remarks
        </label>
        <textarea
          id="remark"
          name="remark"
          rows={3}
          className={`pro-input lg ${getFieldError("remark") && " error"}`}
          {...formik.getFieldProps("remark")}
        />
        {getFieldError("remark") && (
          <span className="error-text">{getFieldError("remark")}</span>
        )}
      </div>

      <div className="col-12 pro-d-flex pro-justify-end pro-mt-4">
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={onClose}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={formik.handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default SupplierPaymentForm;
